import React from "react";
import styled from "styled-components";

// components
import { Avatar } from "components/common";

// utils
import { specialFormatDate } from "utils/date";
import { convertAppLinkStatus } from "utils";

const AppLinkRequestCard = ({ requestInfo, onClick, ...props }) => {
  return (
    <Wrapper onClick={onClick}>
      <UserInfo>
        <Avatar src={requestInfo?.memberImageUrl} size={48} />
        <div data-clarity-mask="True">
          <p className="branchDetail"> {requestInfo?.partnerBranchName}</p>

          <p className="userDetail" >
            {requestInfo.name} &middot; {requestInfo?.mobile}
          </p>

          <p className="dateDetail">{specialFormatDate(requestInfo?.regDts)}</p>
        </div>
      </UserInfo>

      <Status active={requestInfo.intlReqCd === "A"}>
        {convertAppLinkStatus(requestInfo?.intlReqCd)}
      </Status>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 88px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    margin-right: 12px;
  }

  div {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
  }

  p {
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    text-overflow: ellipsis;
  }

  p.userDetail {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: ${(props) => props.theme.colors.primaryTextColor};
  }

  p.branchDetail,
  p.dateDetail {
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.textButtonColor};
    font-feature-settings: "tnum" on, "lnum" on;
  }
`;

const Status = styled.div`
  width: 58px;
  min-width: 58px;
  height: 24px;
  padding: 4px 8px;
  border-radius: 16px;
  background-color: ${(props) =>
    props.active ? "rgba(0, 79, 236, 0.08)" : "rgba(244, 62, 62, 0.08)"};

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${(props) => (props.active ? "#004FEC" : "#F43E3E")};
`;

export default AppLinkRequestCard;
